<template>
  <div class="coupon-list">
    <div v-for="(item, index) in list" :key="item.id" class="item">
      <div class="cont">
        <div class="left">
          <div class="money">
            <span>{{ unit }}</span>
            {{ item.money }}
          </div>
          <div class="fullmoney">{{ lang.full_text }}{{ item.fullmoney }}{{ lang.available }}</div>
        </div>
        <div class="right">
          <div class="name">{{ item.name }}</div>
          <el-popover
            v-if="item.des"
            placement="bottom"
            :title="lang.use_desc"
            width="300"
            trigger="click"
            :content="item.des">
            <div class="desc" slot="reference">{{ item.des }}</div>
          </el-popover>
          <div class="time">{{ lang.validity_period }}:{{ item.endtime }}</div>
        </div>
      </div>
      <div class="btn" @click="receive(item.couponNo, index)">{{ lang.receive }}</div>
    </div>
  </div>
</template>

<script>
import { receivecoupon } from '@/api/coupon'
import { mapGetters } from 'vuex'
export default {
  props: {
    list: {
      type: Array,
      default: []
    }
  },
  computed: {
    lang() {
      return this.$t('coupon')
    },
    ...mapGetters(['isLogin', 'unit'])
  },
  methods: {
    // 领取
    async receive(couponNo, index) {
      await this.$checkLogin()
      receivecoupon({
        couponNo: couponNo
      }).then((res) => {
        if (res.code === 1) {
          this.$message.success(this.lang.receive_success)
          this.list.splice(index, 1)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.coupon-list {
  display: flex;
  overflow-x: auto;
  padding: 10px 0;
  .item {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 243px;
    width: 243px;
    height: 80px;
    background: linear-gradient(107deg, #ff8383 0%, #f14f4f 100%);
    border-radius: 12px;
    margin-left: 30px;
    &:last-child {
      margin-right: 15px;
    }
    .cont {
      display: flex;
      align-items: center;
      position: relative;
      z-index: 99;
      width: 209px;
      height: 68px;
      background: radial-gradient(#fff4e7, #f5ddbe);
      margin-left: -20px;
      &::after,
      &::before {
        content: ' ';
        position: absolute;
        top: -8px;
        left: -8px;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background-color: #f4f4f4;
      }
      &::before {
        top: inherit;
        bottom: -8px;
      }
      .left {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;
        margin-left: 5px;
        width: 80px;
        height: 44px;
        text-align: center;
        .money {
          display: flex;
          align-items: flex-end;
          color: #ff0000;
          font-size: 22px;
          transform: scale(0.83);
          span {
            font-size: 10px;
            padding-right: 2px;
            padding-bottom: 4px;
          }
        }
        .fullmoney {
          color: #aaaaaa;
          font-size: 10px;
          transform: scale(0.83);
        }
        border-right: 1px solid #ccc;
      }
      .right {
        margin-left: 6px;
        .name {
          font-weight: 400;
          font-size: 12px;
          color: #ff0000;
        }
        .desc {
          max-width: 100px;
          font-size: 10px;
          color: #4f4f4f;
          margin-left: -16rpx;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .time {
          color: #aaaaaa;
          font-size: 10px;
          transform: scale(0.83);
          margin-left: -8px;
        }
      }
    }
    .btn {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 100;
      text-align: center;
      width: 62px;
      height: 80px;
      line-height: 80px;
      background: linear-gradient(140deg, #ff8383 0%, #f14f4f 100%);
      border-radius: 12px;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);
      color: #fff;
      font-size: 10px;
    }
  }
}
</style>
